<template>
  <div class="generalTableClass documentItems">
    <table class="table table-striped" id="whDocTable">
      <thead>
      <tr>
        <th class="p-1"> №</th>
        <th class="p-1">{{$t('goods.artikul')}}</th>
        <th class="p-1">{{$t('goods.color')}}</th>
        <th class="p-1">{{$t('goods.size')}}</th>
        <th class="p-1">{{$t('incomes.create.product')}}</th>
        <th class="p-1">{{$t('goods.create.unit')}}</th>
        <th class="p-1">{{$t('incomes.create.price')}}</th>
        <th class="p-1" style="width: 6%; text-align: center;">{{$t('sale.kol-vo')}}</th>
        <!-- <th style="text-align: center">{{$t('pos.inWrapped')}}</th>
        <th style="text-align: center">{{$t('pos.inWrappedTotal')}}</th> -->
        <th class="p-1">{{$t('total-amount')}}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="whItem,index in currentBookingItems" :key="whItem.id + 'field'" v-if="whItem.count > 0">
        <td class="p-1">{{index + 1 }}</td>
        <td class="p-1">{{ whItem.artikul ? whItem.artikul : '-' }}</td>
        <td class="p-1">{{ whItem.color ? whItem.color : '-' }}</td>
        <td class="p-1">{{ whItem.size ? whItem.size : '-' }}</td>
        <td class="p-1">{{ whItem.itemName ? whItem.itemName.substring(0, 30) : '-' }}</td>
        <td class="p-1">{{whItem.unitName}}</td>
        <td class="p-1">
          <span v-if="whItem.priceWholesale > 0 && !isRetail">{{ whItem.priceWholesale | currency({symbol: currentDocCurrency, fractionCount: 2, symbolPosition: 'back'}) }}</span>
          <span v-else-if="whItem.priceUzs > 0 && isRetail">{{ whItem.priceUzs | currency({symbol: currentDocCurrency, fractionCount: 2, symbolPosition: 'back'}) }}</span>
          <span v-else>-</span>
        </td>
        <td class="p-1" style="width: 6%; text-align: center; font-weight: bold;">{{ whItem.count
          }}
        </td>
        <!-- <td style="text-align: center">{{ whItem.wrapped ? getWrappedItemsAmount(whItem.wrappedItems) : 1 }}</td>
        <td style="text-align: center">{{ whItem.wrapped ? getWrappedItemsAmount(whItem.wrappedItems) * whItem.count : whItem.count }}</td> -->
        <td class="p-1">
          <span v-if="whItem.priceWholesale * whItem.priceWholesale > 0 && !isRetail">{{ whItem.priceWholesale * whItem.count | currency({symbol: currentDocCurrency, fractionCount: 2, symbolPosition: 'back'})}}</span>
          <span v-else-if="whItem.priceUzs * whItem.priceUzs > 0 && isRetail">{{ whItem.priceUzs * whItem.count | currency({symbol: currentDocCurrency, fractionCount: 2, symbolPosition: 'back'})}}</span>
          <span v-else>-</span>
        </td>
      </tr>
      </tbody>

      <tfoot>
      <tr>
        <td
          colspan="7"
          class="p-1 pr-3"
          style="text-align: right;"
        >
          <strong class="font-lg">Итого</strong>
        </td>
        <td class="p-1" style="text-align: center; font-weight: bold; vertical-align: middle;">
          {{ totalCount }}
        </td>

        <!-- <td class="p-1"
          style="text-align: center; vertical-align: middle; font-weight: bold;">
          -
        </td>
        <td class="p-1" style="text-align: center; font-weight: bold; vertical-align: middle;">
          {{ getTotalWrappedItemsAmount > 0 ? getTotalWrappedItemsAmount : '-' }}
        </td> -->

        <td class="p-1" v-if="sumPrice > 0"
          style="vertical-align: middle; font-weight: bold;">
          {{ sumPrice | currency({symbol: currentDocCurrency, fractionCount: 2, symbolPosition: 'back'}) }}
        </td>

        <td class="p-1" v-else
          style="vertical-align: middle; font-weight: bold;">
          -
        </td>
      </tr>
      </tfoot>
    </table>
    <!-- <div v-if="loading" class="spinner-wrapper">
      <b-spinner variant="primary"></b-spinner>
    </div> -->
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'BookingItemsTable',

  // DATA
  data() {
    return {
    }
  },

  // COMPUTED PROPERTIES
  computed: {
    ...mapState(['userDepCurrencyName']),
    ...mapState('booking', [
      'currentBookingItems', 'currentDocCurrency', 'currentDocSaleType'
    ]),
    isRetail() {
      if (this.currentDocSaleType == 'RETAIL') {
        return true;
      } else {
        return false;
      }
    },
    getTotalWrappedItemsAmount() {
      let temp = 0;
      if (this.currentBookingItems) {
        this.currentBookingItems.forEach(el => {
          if (el.wrapped) {
            if (el.wrappedItems) {
              el.wrappedItems.forEach(item => {
                temp += item.amount * el.count;
              })
            }
          } else {
            temp += el.count;
          }
        })
      }
      return temp;
    },
    totalCount() {
      let sum = 0;
      if (this.currentBookingItems) {
        if (this.currentBookingItems.length > 0) {
          this.currentBookingItems.forEach(el => {
            sum += el.count;
          });
        }
      }
      return sum;
    },
    sumPrice() {
      let temp = 0;
      this.currentBookingItems.forEach(item => {
        if (this.isRetail) {
          if (item.priceUzs) {
            temp += item.priceUzs ? item.priceUzs * item.count : 0;
          }
        } else {
          if (item.priceWholesale) {
            temp += item.priceWholesale ? item.priceWholesale * item.count : 0;
          }
        }
      });
      return temp
    },
  },

  // METHODS
  methods: {
    getWrappedItemsAmount(wrappedItems) {
      let inWrappedAmount = 0;
      if (wrappedItems) {
        wrappedItems.forEach(item => inWrappedAmount += item.amount)
      }
      return inWrappedAmount;
    },

  },

  // CREATED HOOK
  created() {
  }
}
</script>

<style lang="scss" scoped>
  .generalTableClass {
    .table {
      td, th {
        font-size: 12px;
      }
    }
  }
  .spinner-wrapper {
    position: absolute;
    background: rgba(32, 28, 32, 0.49);
    left: 0;
    right: 0;
    text-align: center;
    top: 0;
    bottom: 0;
    padding-top: 35px;
    z-index: 5;
  }
</style>
